export default {
  // index.tsx columns
  "dailyReports.thead.statisticsTimeDesc": "统计日期",
  "dailyReports.thead.statisticsTimeFrom": "开始时间",
  "dailyReports.thead.statisticsTimeTo": "结束时间",
  "dailyReports.thead.statisticsType": "报表周期",
  "dailyReports.thead.statisticsType.day": "日",
  "dailyReports.thead.statisticsType.week": "周",
  "dailyReports.thead.statisticsType.month": "月",
  "dailyReports.thead.statisticsType.year": "年",
  "dailyReports.thead.totalRegisterUser": "注册",
  "dailyReports.thead.totalFirstDeposit": "开户",
  "dailyReports.thead.totalDepositUser": "总充值\n人数",
  "dailyReports.thead.userTransferRatio": "转化率",
  "dailyReports.thead.totalActiveUser": "活跃",
  "dailyReports.thead.totalFirstDepositAmount": "首存",
  "dailyReports.thead.totalDepositAmount": "存款",
  "dailyReports.thead.totalWithdrawAmount": "取款",
  "dailyReports.thead.depositSubWithdrawAmount": "存-取",
  "dailyReports.thead.depositSubWithdrawAmount.tooltip.deposit": "存款为{green}",
  "dailyReports.thead.depositSubWithdrawAmount.tooltip.withdraw": "取款为{red}",
  "dailyReports.thead.totalBetUser": "投注用户",
  "dailyReports.thead.totalRealBetAmount": "真实投注额",
  "dailyReports.thead.totalWinAmount": "总赢金额",
  "dailyReports.thead.totalPayoutAmount": "游戏派彩",
  "dailyReports.thead.totalPayoutAmount.tooltip": "游戏派彩为负数时平台盈利",
  "dailyReports.thead.totalPayoutAmount.tooltip.profit": "盈利为{green}",
  "dailyReports.thead.totalPayoutAmount.tooltip.loss": "亏损为{red}",
  "dailyReports.thead.totalPromotionAmount": "优惠奖金",
  "dailyReports.thead.claimCashbackAmount": "已领反水",
  "dailyReports.thead.totalCheckinNum": "总签到",
  "dailyReports.thead.todayRegisterCheckinNum": "今日签到",
  "dailyReports.thead.historyRegisterCheckinNum": "历史签到",
  "dailyReports.thead.totalAdminAmount": "修正",
  "dailyReports.thead.totalBalanceAmount": "自有平台余额",
  "dailyReports.thead.totalGainAmount": "盈亏",
  "dailyReports.thead.totalGainAmount.tooltip": "游戏中输或者赢的钱-优惠-反水-修正-奖金=盈亏",
  "dailyReports.thead.totalGainAmount.tooltip.profit": "盈利为{green}",
  "dailyReports.thead.totalGainAmount.tooltip.loss": "亏损为{red}",
  "dailyReports.thead.totalBalanceAmountSub": "余额差值",
  "dailyReports.thead.modifyTime": "更新时间",
  "dailyReports.thead.detail": "统计详情",
  "dailyReports.thead.detail.games": "详情",
  "dailyReports.copy.success": "复制成功!",
  "dailyReports.loading": "数据加载中...",

  // BetStatisticsForGame modal
  "dailyReports.betStatistics.title": "游戏投注统计",
  "dailyReports.betStatistics.gameId": "游戏ID",
  "dailyReports.betStatistics.gameName": "游戏名称",
  "dailyReports.betStatistics.providerId": "供应商ID",
  "dailyReports.betStatistics.providerName": "供应商名称",
  "dailyReports.betStatistics.betNum": "投注次数",
  "dailyReports.betStatistics.totalBetAmount": "总投注金额",
  "dailyReports.betStatistics.totalResultAmount": "总结果金额",
  "dailyReports.betStatistics.totalWinAmount": "总赢金额",
  "dailyReports.betStatistics.summary": "汇总",

  // ExpandedRows titles & thead
  "dailyReports.expanded.thirdPartyBet": "第三方投注",
  "dailyReports.expanded.thirdPartyBet.gameType": "游戏类型",
  "dailyReports.expanded.thirdPartyBet.platform": "平台",
  "dailyReports.expanded.thirdPartyBet.betAmount": "投注",
  "dailyReports.expanded.thirdPartyBet.realBetAmount": "有效投注",
  "dailyReports.expanded.thirdPartyBet.betUserNum": "投注人数",
  "dailyReports.expanded.thirdPartyBet.payout": "派彩",
  "dailyReports.expanded.thirdPartyBet.betOrderNum": "投注单量",
  "dailyReports.expanded.thirdPartyBet.totalSummary": "第三方总合计",
  "dailyReports.expanded.summary": "汇总",

  "dailyReports.expanded.thirdPartyDeposit": "第三方存款",
  "dailyReports.expanded.thirdPartyDeposit.platform": "第三方支付",
  "dailyReports.expanded.thirdPartyDeposit.amount": "存款总额",
  "dailyReports.expanded.thirdPartyDeposit.orderNum": "存款次数",

  "dailyReports.expanded.thirdPartyWithdraw": "第三方取款",
  "dailyReports.expanded.thirdPartyWithdraw.platform": "第三方支付",
  "dailyReports.expanded.thirdPartyWithdraw.amount": "取款总额",
  "dailyReports.expanded.thirdPartyWithdraw.orderNum": "取款次数",

  "dailyReports.expanded.promotion": "优惠",
  "dailyReports.expanded.promotion.discountType": "优惠类型",
  "dailyReports.expanded.promotion.content": "优惠内容",
  "dailyReports.expanded.promotion.amount": "优惠金额",
  "dailyReports.expanded.promotion.depositDiscount": "充值优惠",
  "dailyReports.expanded.promotion.activityDiscount": "活动优惠",

  "dailyReports.expanded.cashback": "返水",
  "dailyReports.expanded.cashback.content": "返水内容",
  "dailyReports.expanded.cashback.amount": "返水金额",

  "dailyReports.expanded.manualDeposit": "手动存款",
  "dailyReports.expanded.manualDeposit.type": "存款类型",
  "dailyReports.expanded.manualDeposit.amount": "存款总额",
};
